import React from 'react';
import PropTypes from 'prop-types';
import { Message } from 'mage-i18n';
// eslint-disable-next-line import/no-extraneous-dependencies
import { SpacerHorizontal, Typography } from '@klarna/bubble-ui';

import SubtitlesWithLinks from './SubtitlesWithLinks';
import StatusIcon from './StatusIcon';

const TranslatedSidebarBlock = ({ tKeyPrefix, status = '' }) => (
  <div style={{ display: 'flex' }}>
    {status && (
      <div>
        <StatusIcon status={status} />
      </div>
    )}
    {status && <SpacerHorizontal small />}
    <div>
      <Typography textToken="text-style/headings/titles/bold/grande">
        <Message path={`${tKeyPrefix}.title`} />
      </Typography>
      <SpacerHorizontal small />
      <SubtitlesWithLinks tPrefix={`${tKeyPrefix}.text_blocks`} />
    </div>
  </div>
);

TranslatedSidebarBlock.propTypes = {
  tKeyPrefix: PropTypes.string.isRequired,
  status: PropTypes.string,
};

export default TranslatedSidebarBlock;
